import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#4ea8c8',
    },
    secondary: {
      main: '#77a47d',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
